module.exports = __webpack_public_path__ + "img/planet.ac6b646e.svg";